import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  AnyProgressBarWidget,
  DiscountMessageBoxWidget,
  DiscountQuantityWidget,
  ShippingProgressBarWidget,
  WidgetTypeType,
} from "@intelligems/ig-types";
import { CircularProgress, Grid } from "@mui/material";

import { selectedWidgets } from "../../store/slices/widgets";

import { DiscountMessageBoxWidgetsOverview } from "./DiscountMessageBoxWidgetsTab/DiscountProgressBarWidgetsOverview";
import { DiscountProgressBarWidgetsOverview } from "./DiscountProgressBarWidgetsTab/DiscountProgressBarWidgetsOverview";
import { DiscountQuantityWidgetsOverview } from "./DiscountQuantityWidgetsTab/DiscountQuantityWidgetsOverview";
import { ShippingProgressBarWidgetsOverview } from "./ShippingProgressBarWidgetsTab/ShippingProgressBarWidgetsOverview";

interface WidgetsTabWrapperProps {
  widgetType: WidgetTypeType;
}

export const WidgetsTabWrapper = ({ widgetType }: WidgetsTabWrapperProps) => {
  const widgets = useSelector(selectedWidgets);
  const filteredWidgets = useMemo(() => {
    return widgets.filter((widget) => widget.widgetType === widgetType);
  }, [widgets, widgetType]);

  // if (widgets.isLoading) {
  //   return (
  //     <Grid container direction={"row"} justifyContent={"center"} item>
  //       <Grid item>
  //         <CircularProgress size={30} />
  //       </Grid>
  //     </Grid>
  //   );
  // }

  // if (widgets.isSuccess) {
  if (widgetType === "quantityButtons") {
    return (
      <DiscountQuantityWidgetsOverview
        quantityWidgets={filteredWidgets as DiscountQuantityWidget[]}
      />
    );
  } else if (widgetType === "discountProgressBar") {
    return (
      <DiscountProgressBarWidgetsOverview
        progressBarWidgets={filteredWidgets as AnyProgressBarWidget[]}
      />
    );
  } else if (widgetType === "messageBoxPopup") {
    return (
      <DiscountMessageBoxWidgetsOverview
        widgetType={widgetType}
        messageBoxWidgets={filteredWidgets as DiscountMessageBoxWidget[]}
      />
    );
  } else if (widgetType === "messageBoxSlideOut") {
    return (
      <DiscountMessageBoxWidgetsOverview
        widgetType={widgetType}
        messageBoxWidgets={filteredWidgets as DiscountMessageBoxWidget[]}
      />
    );
  } else if (widgetType === "shippingProgressBar") {
    return (
      <ShippingProgressBarWidgetsOverview
        shippingProgressBarWidgets={
          filteredWidgets as ShippingProgressBarWidget[]
        }
      />
    );
  }
  return null;
};
